<template>
  <div class="confirmation">
    <div class="heading-icon" style="background-color: #f59e0b">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
        <circle cx="12" cy="12" r="10"></circle>
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
        <circle cx="12" cy="17" r="0.5" fill="currentColor"></circle>
      </svg>
    </div>
    <h1 class="title-with-underline">請確認掛號資料是否正確?</h1>

    <div class="appointment-info">
      <div class="info-item" v-for="(item, index) in infoItems" :key="index">
        <span class="info-label" :class="item.labelColor">{{ item.label }}</span>
        
        <div v-if="Array.isArray(item.value)" class="info-value-group">
          <span class="info-value" :class="item.color" v-for="(val, vIndex) in item.value" :key="vIndex">{{ val }}</span>
        </div>
        <span v-else class="info-value" :class="item.color">{{ item.value }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Confirmation',
  props: {
    clinicName: {
      type: String,
      default: '姜博文診所'
    },
    visitPurpose: {
      type: String,
      default: '體檢 / 健檢'
    },
    examTypeText: {
      type: String,
      default: '成人健檢'
    },
    visitTypeLabel: {
      type: String,
      default: '健檢種類'
    },
    showVisitPurpose: {
      type: Boolean,
      default: true
    },
    showDoctor: {
      type: Boolean,
      default: false
    },
    doctorName: {
      type: String,
      default: ''
    },
    visitTimeSlot: {
      type: String,
      default: '2025-09-11-afternoon'
    },
    patientName: {
      type: String,
      default: '王小明 (本人)'
    },
    selectedAddOns: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    formattedVisitDate() {
      if (!this.visitTimeSlot || this.visitTimeSlot === '由診所人員協助確認') {
        return '由診所人員協助確認';
      }
      
      const lastHyphenIndex = this.visitTimeSlot.lastIndexOf('-');
      if (lastHyphenIndex === -1) return this.visitTimeSlot;
      
      const datePart = this.visitTimeSlot.substring(0, lastHyphenIndex);
      const timeSlot = this.visitTimeSlot.substring(lastHyphenIndex + 1);
      const date = new Date(datePart);
      if (isNaN(date.getTime())) return '日期格式錯誤';

      const month = date.getMonth() + 1;
      const day = date.getDate();
      const weekday = ['日', '一', '二', '三', '四', '五', '六'][date.getDay()];
      const timeSlotText =
        timeSlot === 'morning' ? '上午診' :
        timeSlot === 'afternoon' ? '午診' :
        timeSlot === 'evening' ? '晚診' : '診';

      return `${month}/${day} (${weekday}) ${timeSlotText}`;
    },
    infoItems() {
      const items = [
        { label: '就診院所', value: this.clinicName },
        { label: '就診時段', value: this.formattedVisitDate, color: this.formattedVisitDate === '由診所人員協助確認' ? 'text-danger' : 'text-green' },
        { label: '就診人', value: this.patientName },
        { label: this.visitTypeLabel, value: this.examTypeText, color: 'text-warning' },
      ];

      if (this.showVisitPurpose) {
        items.splice(3, 0, { label: '就診目的', value: this.visitPurpose });
      }

      if (this.showDoctor) {
        items.push({
          label: '看診醫師',
          value: this.doctorName || '由診所安排',
          color: 'text-warning'
        });
      }
      
      if (this.selectedAddOns && this.selectedAddOns.length > 0) {
        items.push({
          label: '加購項目',
          value: this.selectedAddOns,
          color: 'text-warning'
        });
      }
      
      return items;
    }
  }
}
</script>

<style lang="scss" scoped>
.appointment-info {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 24px;

  @media (min-width: 768px) {
    padding: 24px;
  }
}

.info-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 4px;
  border-bottom: 1px solid #e9ecef;
  padding: 12px 0;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    padding: 16px 0;
  }

  &:last-child {
    border-bottom: none;
  }
}

.info-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;

  @media (min-width: 768px) {
    font-size: 18px;
  }
}

.info-value {
  font-size: 16px;
  color: #333;
  font-weight: 700;

  @media (min-width: 768px) {
    font-size: 18px;
  }
}

.info-value-group {
  display: flex;
  flex-direction: column;
  gap: 4px;

  @media (min-width: 768px) {
    align-items: flex-end;
  }
}
</style>
